import type { Address } from '@/types/contracts'
import type { CompanyMember } from '@/types/me'

export const formatCurrency = (value: number, language: string) => {
  const formatter = new Intl.NumberFormat(localeFromLanguage(language), {
    style: 'currency',
    currency: 'EUR'
  })
  return formatter.format(value)
}

export const formatDate = (date: Date | string, language: string) => {
  const formatter = new Intl.DateTimeFormat(localeFromLanguage(language), {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
  return formatter.format(new Date(date))
}

export const formatAddress = (address: Address) =>
  `${address.street} ${address.number}, ${address.postalCode} ${address.city}`

export const emptyValueRepresentation = '-'

const localeFromLanguage = (language: string) => (language === 'fr' ? 'fr-BE' : language === 'en' ? 'en-GB' : 'nl-BE')

export const daysFromNow = (date: Date | string) => {
  const dateFormatted = new Date(date).getTime()
  const todayFormatted = new Date().getTime()
  return Math.ceil((dateFormatted - todayFormatted) / (1000 * 3600 * 24))
}

export const joinMembersNames = (members: CompanyMember[]) => {
  return members.map((member) => `${member.firstName} ${member.lastName}`).join(', ')
}
